import api from './api';

/** The "Primeiros passos" list, in its order. */
export type FirstStepKey = 'telegram' | 'personalExpense' | 'budget' | 'bill' | 'sharedGroup';

export interface FirstSteps {
  /** Each step with when it was first done; null while it is not. */
  steps: Array<{ key: FirstStepKey; doneAt: string | null }>;
  /** A first goal: suggested once the list is done. */
  goalAt: string | null;
}

export const firstStepsApi = {
  async get(): Promise<FirstSteps> {
    const response = await api.get('/users/first-steps');
    return response.data;
  },
};
